export default "__VITE_ASSET__BYc$VewS__"